import { Autocomplete, Divider, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DialogModal from 'components/UI/DialogModal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FiltersDate from './FiltersDate';

interface Props {
    open: boolean;
    vendors: any;
    venues: any;
    modalities: any;
    topic: any;
    countries: any;
    cities: any;
    languages: any;
    trainers:any;
    filters: any;
    startDate: any;
    endDate: any;
    onClose: () => void;
    onReset: () => void;
    onChangeVendor: (value: any) => void;
    onChangeVenues: (value: any) => void;
    onChangeModalities: (value: any) => void;
    onChangeTopic: (value: any) => void;
    onChangeTrainer: (value: any) => void;
    onChangeCountries: (value: any) => void;
    onChangeCities: (value: any) => void;
    onChangeLanguages: (value: any) => void;
    onChangeStartDate: (value: any) => void;
    onChangeEndDate: (value: any) => void;
};


const FilterListModal: React.FC<Props> = ({ open, vendors, venues, modalities, topic, countries,
    cities, languages,trainers, startDate, endDate,
    filters, onClose, onChangeVendor, onChangeModalities, onChangeVenues, onChangeTopic,onChangeTrainer, onReset,
    onChangeCountries, onChangeCities, onChangeLanguages, onChangeStartDate, onChangeEndDate
}) => {
    const { t } = useTranslation();
    return (
        <>
            <DialogModal
                open={open}
                onClose={onClose}
                title={t('T_filter_workshops')}
                maxWidth="md"
                sx={{
                    "& .MuiDialog-paper": {
                        borderRadius: 3,
                        minHeight: "100%",
                        overflow: "hidden",
                    },
                }}
                children={
                    <>
                        <Grid container spacing={2} sx={{
                            mt: 2,
                        }}>
                            <Grid item xs={12} md={6} lg={4}>
                               <Autocomplete
  sx={{ minWidth: 220, maxWidth: 220,"& .MuiInputBase-root": { height: 50 }, }}
  options={filters?.vendors || []}
  getOptionLabel={(option) => option.name || ""}
value={filters?.vendors?.find((v: any) => v.id === vendors) || null} 
  onChange={(_, newValue) => onChangeVendor(newValue?.id ?? "")}
  renderInput={(params) => (
    <TextField
      {...params}
      label={t("T_vendors")}
      variant="outlined"
    />
  )}
/>
</Grid>

<Grid item xs={12} md={6} lg={4}>
  <Autocomplete
    sx={{
      minWidth: 220,
      maxWidth: 220,
      "& .MuiInputBase-root": { height: 50 },
    }}
    options={filters?.modalities || []}
    getOptionLabel={(option) => option.name || ""}
    value={
      filters?.modalities?.find((m: any) => m.id === modalities) || null
    }
    onChange={(_, newValue) =>
      onChangeModalities(newValue ? newValue.id : "")
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label={t("T_modalities")}
        variant="outlined"
      />
    )}
  />
</Grid>
                            <Grid item xs={12} md={6} lg={4}>
    <Autocomplete
      sx={{ minWidth: 220, maxWidth: 220 ,  "& .MuiInputBase-root": { height: 50 },}}
      options={filters?.topics || []}
      getOptionLabel={(option) => option.name || ""}
      value={filters?.topics?.find((t: any) => t.id === topic) || null}
      onChange={(_, v) => onChangeTopic(v ? v.id : "")}
      renderInput={(params) => (
        <TextField {...params} label={t("T_topics")} variant="outlined" />
      )}
    />
  </Grid>

                            <Grid item xs={12} md={6} lg={4}>
    <Autocomplete
      sx={{ minWidth: 220, maxWidth: 220 ,  "& .MuiInputBase-root": { height: 50 },}}
      options={filters?.countries || []}
      getOptionLabel={(option) => option.name || ""}
      value={filters?.countries?.find((c: any) => c.id === countries) || null}
      onChange={(_, v) => onChangeCountries(v ? v.id : "")}
      renderInput={(params) => (
        <TextField {...params} label={t("T_countries")} variant="outlined" />
      )}
    />
  </Grid>
                             <Grid item xs={12} md={6} lg={4}>
    <Autocomplete
      sx={{ minWidth: 220, maxWidth: 220 ,  "& .MuiInputBase-root": { height: 50 },}}
      options={
        filters?.cities?.filter((city: any) => city.countryId === countries) || []
      }
      getOptionLabel={(option) => option.name || ""}
      value={
        filters?.cities?.find((city: any) => city.id === cities) || null
      }
      onChange={(_, v) => onChangeCities(v ? v.id : "")}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("T_cities")}
          variant="outlined"
          disabled={!countries}
        />
      )}
    />
  </Grid>
                             <Grid item xs={12} md={6} lg={4}>
    <Autocomplete
      sx={{ minWidth: 220, maxWidth: 220,  "& .MuiInputBase-root": { height: 50 }, }}
      options={
        cities
          ? filters?.venues?.filter((v: any) => v.cityId === cities)
          : filters?.venues || []
      }
      getOptionLabel={(option) => option.name || ""}
      value={filters?.venues?.find((v: any) => v.id === venues) || null} 
      onChange={(_, v) => onChangeVenues(v ? v.id : "")}
      renderInput={(params) => (
        <TextField {...params} label={t("T_venus")} variant="outlined" />
      )}
    />
  </Grid>
                            <Grid item xs={12} md={6} lg={4}>
    <Autocomplete
      sx={{ minWidth: 220, maxWidth: 220 ,  "& .MuiInputBase-root": { height: 50 },}}
      options={filters?.trainers || []}
      getOptionLabel={(option) => option.firstName + " " + option.lastName || ""}
      value={filters?.trainers?.find((l: any) => l.id === trainers) || null}
      onChange={(_, v) => onChangeTrainer(v ? v.id : "")}
      renderInput={(params) => (
        <TextField {...params} label={t("T_trainers")} variant="outlined" />
      )}
    />
  </Grid>

   <Grid item xs={12} md={6} lg={4}>
    <Autocomplete
      sx={{ minWidth: 220, maxWidth: 220 ,  "& .MuiInputBase-root": { height: 50 },}}
      options={filters?.languages || []}
      getOptionLabel={(option) => option.name || ""}
      value={filters?.languages?.find((l: any) => l.id === languages) || null}
      onChange={(_, v) => onChangeLanguages(v ? v.id : "")}
      renderInput={(params) => (
        <TextField {...params} label={t("T_languages")} variant="outlined" />
      )}
    />
  </Grid>
                            <FiltersDate
                                onChangeFrom={onChangeStartDate}
                                onChangeTo={onChangeEndDate}
                                valueFrom={startDate}
                                valueTo={endDate}
                            />
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>

                                <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                    <Button
                                        variant="text"
                                        color="primary"
                                        onClick={onClose}
                                        style={{
                                            marginInline: "10px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t("T_close")}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={onReset}
                                        style={{
                                            marginInline: "10px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t("T_reset")}
                                    </Button>
                                </Stack>
                            </Grid>

                        </Grid>
                    </>
                }
            />
        </>
    );
}

export default FilterListModal;